import { Select } from 'antd'
import styled from 'styled-components'

const { Option } = Select

export const StyledOption = styled(Option)``
